<template>
  <nav
    class="border-Blue-Primary bg-Gray-200 student:bg-white fixed -top-full left-[10%] z-[1000] rounded border-2 px-8 pb-5 pt-6 shadow-lg transition-all md:focus-within:-top-1"
    aria-label="Accessibility navigation"
  >
    <ul class="space-y-2">
      <li>
        <button
          tabindex="1"
          class="focus-default text-h2 px-2 hover:underline"
          type="button"
          @click="jumptoid('jump-navigation')"
        >
          <span>{{ $t("navigate.toNav") }}</span>
        </button>
      </li>
      <li>
        <button
          tabindex="1"
          class="focus-default text-h2 px-2 hover:underline"
          type="button"
          @click="jumptoid('jump-contend-start')"
        >
          <span>{{ $t("navigate.toPage") }}</span>
        </button>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
useTabHelper();

function jumptoid(id: string) {
  const el = document.getElementById(id);

  if (el?.getElementsByTagName("a")[0]) {
    el?.getElementsByTagName("a")[0]?.focus();
  } else {
    el?.focus();
  }

  el?.scrollIntoView({
    behavior: "smooth",
  });
}
</script>
